import { default as React } from "react";


import { WithTranslation, withTranslation } from "react-i18next";
import Row from "./row";
import { AtcDto, ScheduledExchangesDto, PriceSpreadDto, CongestionIncomeDto, LtnDto, ShadowAuctionAtcDto, IntradayAtcDto } from "core/backend/data";
import { keys } from "ts-transformer-keys";

interface OwnProps {
    scrollPosition?: { left: number, top: number };
    border: string;
    dates: Date[];
    atcData: AtcDto[];
    qtyData: ScheduledExchangesDto[];
    psData: PriceSpreadDto[];
    ciData: CongestionIncomeDto[];
    ltnData: LtnDto[];
    sAtcData: ShadowAuctionAtcDto[];
    iAtcData: IntradayAtcDto[];
}

const List = ({ t, border, dates, atcData, qtyData, psData, ciData, ltnData, sAtcData, iAtcData, scrollPosition }: OwnProps & WithTranslation) => {
    const top = Math.max(0, ((scrollPosition?.top || 0) - 16));
    const left = Math.max(0, ((scrollPosition?.left || 0) - 16));

    const hasAtcData = keys<AtcDto>().map(m => m.toString()).includes("border_" + border.toUpperCase());
    const hasQtyData = keys<ScheduledExchangesDto>().map(m => m.toString()).includes("border_" + border.toUpperCase());
    const hasPsData = keys<PriceSpreadDto>().map(m => m.toString()).includes("border_" + border.toUpperCase());
    const hasCiData = keys<CongestionIncomeDto>().map(m => m.toString()).includes("border_" + border.toUpperCase());
    const hasLtnData = keys<LtnDto>().map(m => m.toString()).includes("border_" + border.toUpperCase());
    const hasSAtcData = keys<ShadowAuctionAtcDto>().map(m => m.toString()).includes("border_" + border.toUpperCase());
    const hasIAtcData = keys<IntradayAtcDto>().map(m => m.toString()).includes("initial_" + border.toUpperCase());

    return (
        <table id="datatable">
            <thead>
                <tr>
                    <th className="fixedDateColumn" style={{ top: top + "px", left: left + "px" }}>{t("common:Date")}</th>
                    {hasAtcData && <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_borderDataOverview:Atc")}</th>}
                    {hasQtyData && <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_borderDataOverview:Sec")}</th>}
                    {hasPsData && <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_borderDataOverview:Ps")}</th>}
                    {hasCiData && <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_borderDataOverview:Ci")}</th>}
                    {hasLtnData && <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_borderDataOverview:Ltn")}</th>}
                    {hasSAtcData && <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_borderDataOverview:SaAtc")}</th>}
                    {hasIAtcData && <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_borderDataOverview:IAtc")}</th>}
                </tr>
            </thead>
            <tbody>
                {
                    dates
                    && atcData.length + qtyData.length + psData.length + ciData.length + ltnData.length + sAtcData.length + iAtcData.length > 0
                    && dates.map((d) => <Row key={d.toISOString()} border={border} date={d} left={left} atcData={atcData} qtyData={qtyData} psData={psData} ciData={ciData} ltnData={ltnData} sAtcData={sAtcData} iAtcData={iAtcData} />)
                }
            </tbody>
        </table>
    );
};

const translated = withTranslation("page_borderDataOverview")(List);

export default translated;